export default "__VITE_ASSET__JcqrOeiR__"